import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeliveryOptions from './DeliveryOptions';
import KioskDeliveryTitle from './KioskDeliveryTitle';
import Props from './DeliveryComponent';
import Translation from "../../../../shared/Translation";
import { isListingMonetizationAEnabled } from '@b/helpers/ABTesting';
import { DeliveryOptionsSelect } from './DeliveryOptionsSelect';

class Delivery extends Component<Props> {
    render() {
        const hasShippingMethods = this.props.deliveryOptions?.some((option) => option.requires_shipping);
        const showSelect = this.props.deliveryOptions.length > 1 && !hasShippingMethods && isListingMonetizationAEnabled();
        const hasPaidOption = this.props.deliveryOptions.some((option) => option.price && option.price.amount > 0);

        const deliveryHeaderTranslation = isListingMonetizationAEnabled()
          ? 'checkout__delivery_method'
          : 'checkout__delivery_options';

        return (
            <section className="checkout-form__section">
                <div className="form-card">
                    <div className="form-card__header">
                        {this.props.isKioskMode
                            ? !this.props.singularDeliveryOption && <KioskDeliveryTitle />
                            : (
                              <h4 className="form-card__heading">
                                <Translation>{deliveryHeaderTranslation}</Translation>
                              </h4>
                            )
                        }
                    </div>
                    <form className="form-card__content">
                        {showSelect && (
                          <DeliveryOptionsSelect
                            onDeliveryChange={this.props.onDeliveryChange}
                            onDeliveryPhoneChange={this.props.onDeliveryPhoneChange}
                            onCountryCodeChange={this.props.onCountryCodeChange}
                            onAddressChange={this.props.onAddressChange}
                            deliveryOptions={this.props.deliveryOptions}
                            selectedOption={this.props.selectedOption}
                            disabled={this.props.loading}
                            phone={this.props.phone}
                            countryCode={this.props.countryCode}
                            address={this.props.address}
                            isKioskMode={this.props.isKioskMode}
                            kioskCollectCustomerEmail={this.props.kioskCollectCustomerEmail}
                            onEmailChange={this.props.onEmailChange}
                            onMobileFocus={this.props.onMobileFocus}
                            onEmailFocus={this.props.onEmailFocus}
                            email={this.props.email}
                            singularDeliveryOption={this.props.singularDeliveryOption}
                            gatewayType={this.props.gatewayType}
                            hasPaidOption={hasPaidOption}
                          />
                        )}
                        {!showSelect && (
                            <div className="input">
                                <div className={`delivery-option__input input__radios ${this.props.singularDeliveryOption && 'delivery__option--singular'}`}>
                                    {this.props.deliveryOptions.map((option, i) => {
                                        return <DeliveryOptions
                                            delivery_option={option}
                                            onDeliveryChange={this.props.onDeliveryChange}
                                            onDeliveryPhoneChange={this.props.onDeliveryPhoneChange}
                                            onCountryCodeChange={this.props.onCountryCodeChange}
                                            onPhoneClear={this.props.onPhoneClear}
                                            onAddressChange={this.props.onAddressChange}
                                            price={option.price.amount}
                                            selected={option.id === this.props.selectedOption}
                                            phone={this.props.phone}
                                            countryCode={this.props.countryCode}
                                            address={this.props.address}
                                            isKioskMode={this.props.isKioskMode}
                                            kioskCollectCustomerEmail={this.props.kioskCollectCustomerEmail}
                                            onEmailChange={this.props.onEmailChange}
                                            onMobileFocus={this.props.onMobileFocus}
                                            onEmailFocus={this.props.onEmailFocus}
                                            email={this.props.email}
                                            singularDeliveryOption={this.props.singularDeliveryOption}
                                            gatewayType={this.props.gatewayType}
                                            disabled={this.props.loading}
                                            single={this.props.deliveryOptions.length === 1}
                                            key={i}
                                            hasPaidOption={hasPaidOption}
                                        />
                                    })}
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </section>
        )
    }
}

Delivery.propTypes = {
    deliveryOptions: PropTypes.arrayOf(Object).isRequired,
    gatewayType: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    address: PropTypes.object.isRequired,
    onAddressChange: PropTypes.func.isRequired,
    onDeliveryChange: PropTypes.func.isRequired,
    selectedOption: PropTypes.number,
}

export default Delivery
